import React from 'react'

// import footer_top from "../assets/duck-images/footer-shape-top.svg"
import { Link } from 'react-router-dom'
import { FaTwitter, FaTelegramPlane } from "react-icons/fa"

import twitter from "../assets/duck-images/twitter-x-logo.png"

function Footer() {
    return (
        <>
            {/* <img src={footer_top} alt="footer_top" className='img-fluid footer_top' /> */}
            <footer>
                <div className="container">
                    <div className="row justify-content-center text-center">
                        <div className="icons mb-3">
                            {/* <Link to="https://twitter.com/duck_goose_game" target='_blank'>
                                <i className="fa-brands fa-twitter mx-2"></i>
                            </Link> */}
                            {/* <a href="#">
                                <i className="fa-brands fa-instagram mx-2"></i>
                            </a>
                            <a href="#">
                                <i className="fa-brands fa-discord mx-2"></i>
                            </a> */}
                        </div>
                        <div className="text">
                            <small>
                                © 2023 Duck Duck Goose Game  |
                                <Link to="https://twitter.com/duck_goose_game" target='_blank'>
                                    <img src={twitter} alt="icon" className='img-fluid mx-2' style={{ height: "40px", width: "40px" }} />
                                    {/* <FaTwitter className='mx-2' /> */}
                                </Link>
                                <Link to="https://t.me/duckduckgoosegame" target='_blank'>
                                    <FaTelegramPlane className='mx-2' />
                                </Link>

                            </small>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer
